export default __webpack_public_path__ + "static/media/table_cancer_Cn.f7023682.webp";